<!--
 * @Description: 首页图片弹窗（打开首页时弹出一张图片，图片下方关闭按钮，图片不可点击）
 * @Author: hanyu
 * @Date: 2026-10-16
-->
<template>
  <Modal v-model="showModal"
         footer-hide
         :closable="false"
         :mask-closable="false"
         :width="width"
         :styles="modalStyles"
         class-name="home-popup-modal">
    <div class="popup-wrap">
      <!-- 弹窗图片：本地静态资源，不可点击，仅作展示 -->
      <img class="popup-img"
           :src="imgUrl"
           alt="首页活动弹窗" />
      <!-- 右上角关闭按钮（已隐藏，改用图片下方关闭按钮） -->
      <!-- <img class="close-btn"
           src="~@/assets/image/activity/national-day/modal-close.png"
           alt="关闭"
           @click="handleClose" /> -->
      <!-- 图片下方关闭按钮：点击关闭弹窗 -->
      <Button class="close-text-btn"
              type="primary"
              @click="handleClose">
        关闭
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'HomePopupModal',
  data() {
    return {
      // 弹窗显示状态，由父组件控制（每次打开首页置为 true）
      showModal: false,
      // 弹窗宽度（px），图片按此宽度等比缩放；原图 1055x1491，按需调整展示大小
      width: 500,
      // 图片地址：放在 static/images 目录下，以根路径引用
      imgUrl: '/images/index/index-warn.png'
    };
  },
  computed: {
    /**
     * 弹窗垂直居中定位样式
     * iView Modal 默认 top:100px（距顶定位），这里用 top:50% + 负 margin-top（图片真实高度一半）实现居中。
     * 注意：不使用 transform，避免占用 .ivu-modal 的 transform 与 iView 进入/退出动画冲突导致卡顿。
     * 额外减去 24px，补偿悬浮在图片下方的关闭按钮（间距 16px + 按钮高约 32px 的一半），使整体视觉居中。
     */
    modalStyles() {
      const height = this.width * 1491 / 1055;
      return {
        top: '50%',
        marginTop: (-(height / 2) - 24) + 'px'
      };
    }
  },
  methods: {
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.showModal = false;
    }
  }
};
</script>

<!--
 * iView Modal 通过 teleport 渲染到 body，class-name 落在 body 上的元素，
 * 不带组件 scoped 属性，因此相关样式必须用全局（非 scoped）样式才能命中。
-->
<style lang='less'>
/* 首页图片弹窗：弹窗内容透明、去内边距 */
.home-popup-modal .ivu-modal-content {
  background: transparent;
  box-shadow: none;
}

.home-popup-modal .ivu-modal-body {
  padding: 0;
}

/* 弹窗容器：预设与图片一致的比例，图片未加载时也先占好高度，避免弹窗高度跳动卡顿 */
.home-popup-modal .popup-wrap {
  position: relative;
  aspect-ratio: 1055 / 1491;

  .popup-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }

  /* 右上角关闭图标（当前已隐藏，保留样式便于后续恢复） */
  .close-btn {
    display: none;
    position: absolute;
    top: -60px;
    left: 50%;
    transform: translateX(-50%);
    width: 48px;
    height: 48px;
    cursor: pointer;
  }

  /* 图片下方关闭按钮：绝对定位悬浮在图片底部之下，不占文档流，保持弹窗高度预占逻辑不变 */
  .close-text-btn {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 16px;
    min-width: 120px;
    cursor: pointer;
  }
}

/* 居中已由 :styles（modalStyles）以 top:50% + 负 margin-top 实现，见上方 computed，
   不再使用 class-name 选择器控制定位，避免不同 iView 版本下选择器不生效 */
</style>
